module.exports = __webpack_public_path__ + "img/aa20e6c.svg";